/* eslint-disable */
export const maxLifetime = 30

export default [
[ 0, 1000 ],
[ 1, 497 ],
[ 2, 313 ],
[ 3, 216 ],
[ 4, 126 ],
[ 5, 74 ],
[ 6, 61 ],
[ 7, 48 ],
[ 8, 44 ],
[ 9, 35 ],
[ 10, 22 ],
[ 11, 19 ],
[ 12, 12 ],
[ 13, 10 ],
[ 14, 0 ]
]
